const searchChannels = {
	$root: null,
	IncomingInstanceOfComponent: null,
	searchChannelElement: null,
	infoBox: null,
	value: null,
	re: null,
	channels: [],
	lastKeyCode: null,
	init: function (context, searchId, $root, IncomingInstanceOfComponent) {
		this.$root = $root || document;
		this.IncomingInstanceOfComponent = IncomingInstanceOfComponent;
		this.findSearchInput(searchId || 'searchChannels');
		if (!this.searchChannelElement) return;

		this.channels = this.prepareObjectToSearch(this.findAllChannels(context));
		this.getValue();
		this.createClearInputEvent();
	},
	findSearchInput: function (searchId) {
		this.searchChannelElement = this.$root.querySelector(`#${searchId}`)
	},
	changeValue: function (value) {
		return this.value = value;
	},
	changeRe: function () {
		this.value = this.value.trim();
		const valueArray = this.value.split(' ');
		const valueRegExp = [];
		if (this.value !== '') {
			valueArray.forEach(value => {
				valueRegExp.push(new RegExp(value, 'i'));
			});
		}
		return this.re = valueRegExp;
	},
	getValue: function () {
		this.searchChannelElement.addEventListener('keyup', e => this.detectEnterKey(e.keyCode));
		this.searchChannelElement.addEventListener('keydown', e => this.lastKeyCode = e.keyCode);
	},
	changeValueEvent: function () {
		this.changeValue(this.searchChannelElement.value);

		if (this.detectLengthOfValue()) {
			this.changeTab('.action-tab__tabs .action-tab__tab'); // TODO: funkcja jest zależna od globalnego modułu "zakładek"
			this.changeRe();
			this.changeIconDependsOnValue();

			if (this.IncomingInstanceOfComponent) {
				// if (this.IncomingInstanceOfComponent.showButtonMore) {
				this.IncomingInstanceOfComponent.tirggerShowMore();
				this.IncomingInstanceOfComponent.shownAllElements = true;
				// }
			}

			// console.log('PacketsTv.shownAllElements => search', this.IncomingInstanceOfComponent.shownAllElements);

			const filtered = this.channels.filter(channel => {
				let found = false;
				this.re.forEach(text => {
					// console.log('text', text, 'text.test(channel.channel)', text.test(channel.channel));
					if (text.test(channel.channel)) {
						found = true;
					}
				});
				return found;
			});
			// console.log('filtered', filtered);

			this.channels.forEach(channel => {
				channel.element.classList.remove('in-package');
				if (this.getUniqueFoundedChannels(filtered).length !== 0) {
					channel.element.classList.add('not-in-package');
					channel.element.setAttribute('aria-hidden', 'true');
				} else {
					channel.element.classList.remove('not-in-package');
					channel.element.setAttribute('aria-hidden', 'false');
				}
			});

			this.prepareInfoAboutFoundedChannels(this.getUniqueFoundedChannels(filtered).length);

			filtered.forEach(channel => {
				if (channel.element.parentElement.classList.contains('hiddenPackages')) {
					this.dispatchMoreCircleClick(channel.element.parentElement.previousSibling);
				}
				channel.element.classList.remove('not-in-package');
				channel.element.classList.add('in-package');
				channel.element.setAttribute('aria-hidden', 'false');
			});
			this.searchChannelElement.blur();
		} else {
			// Set it if search on "empty" input search
			this.prepareInfoAboutFoundedChannels();
		}
		const that = this;
		setTimeout(function () {
			that.infoBox.focus();
		}, 100);
	},
	prepareInfoAboutFoundedChannels: function (amount) {
		if (!this.infoBox) {
			this.infoBox = document.createElement('p');
			this.infoBox.classList.add('search-channels__info');
			this.infoBox.setAttribute('role', 'alert');
			this.infoBox.setAttribute('tabindex', '-1');
		}

		this.setTextInInfoBox(amount);
		this.searchChannelElement.parentElement.appendChild(this.infoBox);
	},
	setTextInInfoBox: function (amount, clearInput) {
		const regularName = amount === 1 ? 'kanał' : amount < 5 ? 'kanały' : 'kanałów';

		if (this.detectLengthOfValue()) {
			if (amount > 0) {
				return this.infoBox.innerText =
					`Znaleziono ${amount} ${regularName} pasujących do frazy "${this.searchChannelElement.value}"`;
			} else {
				return this.infoBox.innerText =
					`Brak kanałów pasujących do frazy "${this.searchChannelElement.value}"`;
			}
		} else {
			if (this.infoBox) {
				return this.infoBox.innerText = clearInput ? '' : 'Proszę wpisać nazwę kanału';
			}
		}
	}, 
	getUniqueFoundedChannels: function (arr) {
		return [...new Set(arr.map(item => item.channel))];
	},
	detectLengthOfValue: function () {
		return this.searchChannelElement.value.length;
	},
	changeIconDependsOnValue: function () {
		const btn = this.searchChannelElement.nextElementSibling;
		const btnSpan = btn.querySelector("span");
		if (this.detectLengthOfValue()) {
			this.searchChannelElement.classList.add('filledInput');
			if (btn.getAttribute("data-text-clear")) {
				btnSpan.innerText = btn.getAttribute("data-text-clear");
			}
		} else {
			this.searchChannelElement.classList.remove('filledInput');
			if (btn.getAttribute("data-text-search")) {
				btnSpan.innerText = btn.getAttribute("data-text-search");
			}
		}
	},
	detectEnterKey: function (key) {
		if (!this.detectLengthOfValue()) {
			// console.log('this.searchChannelElement', this.searchChannelElement);
			this.searchChannelElement.classList.remove('filledInput');
			if(this.infoBox) {
				this.infoBox.innerText = '';
			}
		}
		if (key !== 13) return;
		this.changeValueEvent();
	},
	changeTab: function (tabSelector) {
		const event = document.createEvent('Event');
		event.initEvent('click', false, true);
		const tabs = [...this.$root.querySelectorAll(tabSelector)];
		const setActiveTab = tabs.find(el => {
			const dataTabValue = el.getAttribute('data-tab')
			if (dataTabValue === null || dataTabValue === '0') {
				return el;
			}
		});
		if (setActiveTab == null) return;
		setActiveTab.dispatchEvent(event);
	},
	findAllChannels: function (context) {
		return context.querySelectorAll('[data-channel]');
	},
	prepareObjectToSearch: function (nodeList) {
		return Array.from(nodeList).map((element) => {
			return {
				channel: element.dataset.channel,
				element: element
			}
		});
	},
	createClearInputEvent: function () {
		const btn = this.searchChannelElement.nextElementSibling;
		btn.addEventListener('click', _ => {
			this.lastKeyCode = 13;
			if (btn.previousElementSibling.classList.contains('filledInput')) {
				this.clearInput(btn);
				btn.focus();
				return;
			}
			this.changeValueEvent();
		});
	},
	clearInput: function () {
		const btn = this.searchChannelElement.nextElementSibling;
		const btnSpan = btn.querySelector("span");

		if (!this.searchChannelElement.classList.contains('filledInput')) return;

		this.searchChannelElement.value = null;
		this.searchChannelElement.classList.remove('filledInput');
		this.searchChannelElement.classList.remove('filled');
		if (btn.getAttribute("data-text-search")) {
			btnSpan.innerText = btn.getAttribute("data-text-search");
		}

		this.dispatchChangeEvent();
		this.findAllHiddenPackagesWrappers();
		this.channels.forEach(channel => {
			channel.element.classList.remove('in-package');
			channel.element.classList.remove('not-in-package');
			channel.element.setAttribute('aria-hidden', 'false');
		});
		this.setTextInInfoBox(undefined, true);
	},
	findAllHiddenPackagesWrappers: function () {
		const hiddenPackages = Array.from(this.$root.querySelectorAll('.hiddenPackages'));

		hiddenPackages.forEach(pack => {
			if (!pack.style.display || pack.style.display !== 'none') {
				const packCircle = pack.parentElement.querySelector('.arrow__container');
				this.dispatchMoreCircleClick(packCircle);
			}
		});
	},
	dispatchChangeEvent: function () {
		const event = document.createEvent('Event');
		event.initEvent('change', false, true);
		this.searchChannelElement.dispatchEvent(event);
	},
	dispatchMoreCircleClick: function (target) {
		const event = document.createEvent('Event');
		event.initEvent('click', false, true);
		target.firstElementChild.dispatchEvent(event);
	}
};

// export function prepareAllPossibleSearchEngines($root = document, IncomingInstanceOfComponent) {
export function prepareAllPossibleSearchEngines($root, IncomingInstanceOfComponent) {
	const targetsInputs = $root.querySelectorAll(`[data-search-engine-for]`);
	// console.log('targetsInputs', targetsInputs);
	if (!targetsInputs.length) return;

	targetsInputs.forEach(target => {
		Object.create(searchChannels).init(
			$root.querySelector(`#${target.dataset.searchEngineFor}`),
			target.id,
			$root,
			IncomingInstanceOfComponent
		)
	});
}
